import TenantContainer from 'components/tenant/TenantContainer';

const TenantPage = () => {
  return <TenantContainer />;
};
export default TenantPage;
